import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useIdleTimer } from 'react-idle-timer';
import { getItemFromStore, setItemToStore } from '../helpers/utils';
import InactivityScreen from './auth/basic/InactivityScreen';

const TIME_IN_MINUTES = 1 * 30 * 1000; // tiempo para inactividad a 1 minuto (cambiar en producción)

const IdleHandler = () => {
  const [showInactivityScreen, setShowInactivityScreen] = useState(false);
  const location = useLocation();

  // Callback que se invoca cuando se detecta inactividad
  const handleOnIdle = () => {
    console.log('User inactive, proceeding to logout...');

    const currentuser = getItemFromStore('currentuser', null);
    const isGuruRoute = location.pathname.toLowerCase().startsWith('/guru');

    // Limpiar datos de sesión si hay usuario autenticado
    if (currentuser) {
      setItemToStore('currentuser', null);
      setItemToStore('reportCompanyFilter', '');
      setItemToStore('reportPeriodType', 'day');
      setItemToStore('reportSelectedOrganizationId', 0);
      setItemToStore('reportSelectedOrganizationName', '');
      setItemToStore('reportExamResultFilter', '');
    }

    // Si es usuario GURU/Truck O si estamos en ruta GURU, mostrar pantalla de inactividad
    const isGuruUser = currentuser && currentuser.organizationType && currentuser.organizationType.toLowerCase() === 'truck';

    if (isGuruUser || isGuruRoute) {
      setShowInactivityScreen(true);
    } else {
      // Para otros usuarios, redirigir directamente al login
      window.location.href = '/';
    }
  };

  // Inicializamos la detección de inactividad
  useIdleTimer({
    timeout: TIME_IN_MINUTES,
    onIdle: handleOnIdle,
    debounce: 500,
  });

  // Renderizar pantalla de inactividad si está activa
  if (showInactivityScreen) {
    return <InactivityScreen />;
  }

  return null;
};

export default IdleHandler;
